module.exports = __webpack_public_path__ + "img/SKMJ_place5.6b1b8f9e.jpg";